export default __webpack_public_path__ + "static/21-4d6af8f94edcf10f2a5c4da29baad44b.webp";